// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("assets/img/icon-leaf.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".year[data-v-3143ea37]{margin-top:-50px}.leaf[data-v-3143ea37]{position:relative;height:100px;left:-35px;top:70px;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat}.leaf-input[data-v-3143ea37]{position:absolute;top:24px;left:14px}", ""]);
// Exports
module.exports = exports;
